import React, { useEffect, useMemo } from "react";

import './CategoriasRRHHList.css';
import RRCategoriasRRHH from "../renderRows/RRCategoriasRRHH";

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowLeftLong } from "@fortawesome/free-solid-svg-icons";

import { useNavigate } from "react-router-dom";
import { checkDoubleQuotes, removeDoubleQuotesFromFilter } from "../../utils/funciones";
import normalizeText from "../../utils/normalizeText";

const CategoriasRRHHList = ({categoriasList,filter,handleEditCategoria}) => {

    const navigate = useNavigate();

    let categoriasFiltered = useMemo(()=> categoriasList.filter(c => {
        return filter != '' ? 
            checkDoubleQuotes(filter) ?
                (normalizeText(c.codigo) == removeDoubleQuotesFromFilter(filter) || normalizeText(c.descrp) == removeDoubleQuotesFromFilter(filter))
            :
                (normalizeText(c.codigo).includes(normalizeText(filter)) || normalizeText(c.descrp).includes(normalizeText(filter)))
        : true
    }), [categoriasList, filter]);

    return <div className="categoriasRRHHListDiv">
        <button onClick={()=>navigate('/abms')} className="goBackBtn"><FontAwesomeIcon className="iconArrowBack" icon={faArrowLeftLong}/></button>
        {(categoriasList == undefined) ? <h3 className="warningStatusMsg">Cargando<span>.</span><span>.</span><span>.</span></h3> : (categoriasFiltered.length == 0) ? <h3 className="warningStatusMsg">No hay categorias de RRHH para mostrar</h3> : categoriasFiltered.map((c, i) => <RRCategoriasRRHH c={c} index={i} handleEditCategoria={handleEditCategoria}/>)}
    </div>

}

export default CategoriasRRHHList;